import HeaderLogo from 'assets/icons/headerIcon.svg'
import React from 'react'
import { Button, Link } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { LANDING, LIQUIDITY_INFO } from 'routes'
import { useStyles } from './styles'


export const LandingHeader = (): JSX.Element => {
  const { wrap, logoContainer, logoFirstName, logoLastName, buttonsContainer, blogButtonContainer, blogButton, appButton } = useStyles()
  const history = useHistory()
  return (
    <header className={wrap}>
      <div onClick={() => history.push(LANDING)} className={logoContainer}>
        <img src={HeaderLogo} alt="header-logo" />  <span className={logoFirstName}>One</span><span className={logoLastName}>Ledger</span>
      </div>
      <div className={buttonsContainer}>
        <Link
          className={blogButtonContainer}
          rel="noreferrer"
          target={'_blank'}
          href="https://blog.oneledger.io"
        >
          <Button variant="outlined" className={blogButton}>
            {'landing_header_blog_button'.localized()}
          </Button>
        </Link>
        <Link className={blogButtonContainer} href={LIQUIDITY_INFO}>
          <Button variant="outlined" className={appButton}>
            {'landing_header_app_button'.localized()}
          </Button>
        </Link>
      </div>
    </header>
  )
}
